import { Justification } from "#models/justification.model";
import { Trade } from "#models/trade.model";
import {
  LogicQuestion,
  SmartActivityId,
} from "#models/variables/logic-question.model";

export class Activity {
  ID: string;
  Code: string;
  Name: string;
  JobTemplateID?: string;
  PrimaryResourceID?: string;
  LogicDependencyID?: string;
  SmartActivityID?: string;
  WorkListItemID?: number;
  PrimaryResource?: Resource;
  LogicDependency: LogicQuestion;
  SmartActivity: SmartActivityId;
  CrewSize?: number;
  ManHours?: number;
  Duration?: number;
  Justification?: Justification;
  JustificationID?: number;
  Comments?: string;
  PhaseID?: string;
  PhaseName?: string;
  MilestoneTypeID?: string;
  ExecutionActivityTypeID?: string;
  ProjectType?: string;
  ProjectTypeID?: string;
  TAW?: string;
  TurnAroundAdditionalWorkID?: string;
  Disabled?: boolean;
  JobTemplateActivityID?: string;
  LogicReverse?: boolean;
  // All the additional resources that are not the primary resource
  ActivityResources?: Array<Resource>;
  CalendarID?: string;
  WorklistActivityResources?: Array<Resource>;
  Notes?: string;
  TotalCalculatedManhours?: number;
  RevisionVersion?: string;
  TotalCalculatedDuration?: number;
  TotalManHours?: number;
  WorklistJobTemplateID: number;
  PreviewTotalDuration?: number;
  PreviewTotalManHours?: number;
  PreviewManHours?: number;
  PreviewDuration?: number;

  DisableJustification: string;
  ActivityOrder: number;
  RussianDescription?: string;
  KazakhDescription?: string;
  SmartCode: string;
  Factor?: number;
  EquipmentItemsID?: string;
  CustomActivityArcadisTableID?: string;
  tempUUID?: string;
}

export class Resource {
  ID?: string;
  TradeID: string;
  CrewSize: number;
  CalculatedDuration: number;
  CalculatedManHours: number;
  RoundedDuration: number;
  RoundedManHours: number;
  PreviewCalculatedDuration?: number;
  PreviewCalculatedManHours?: number;
  PreviewRoundedDuration?: number;
  PreviewRoundedManHours?: number;
  Trade?: Trade;
  LogicReverse?: boolean;
  Tasks: Array<ResourceTask>;
  OverriddenCrewSize?: number;
  OverriddenDuration?: number;
  Remove?: boolean;
  HasNullError?: boolean;
  CrewSizeVariable?: ResourceTask;
  WorklistJobTemplateID: number;
  IsOverridden?: boolean;
  CopyPrimaryResourceTask?: boolean;
  MarkAsNotOverridden?: boolean;
}

export class ResourceTask {
  ID: string;
  ResourceID: string;
  VariableID: string;
  VariableType: number;
  Output: number;
  CrewSizeVariable: boolean;
}

export class ActivityMetrics {
  ID: string;
  Activities: number;

  OverridenActivities: number;

  OverridenActivitiesPercentage: number;
}

export class CustomActivityEquipment {
  ID: string;
  Name: string;
  Description: string;
  Order: string;
}

export class ActivityArcadisTable {
  ID: string;
  ArcadisTableName: string;
  Description: string;
  Order: string;
  XlsAddress: string;
}

export class ConditionFactor {
  ID: string;
  Description: string;
  Factor: string;
  Type: string;
}
export class ExcelActivitiesData {
  Name: string = null;
  CVXPhase: string = null;
  PrimaryResource: string = null;
  CrewSize: string = null;
  Duration: string = null;
  SecondaryResource: string = null;
  Resource3: string = null;
  Resource4: string = null;
  Resource5: string = null;
  // Flexible support for additional resources
  [key: string]: any;
}

export class MaterialFactor {
  ID: string;
  Description: string;
  Factor: string;
}
